const ReviewsRouter = [
    {
        path: "list-reviews",
        name: "list",
        component: () => import("@/views/admin/reviews"),
        default: true,
        meta: {
            model: "reviews",
        },
    },
    {
        path: "list-reviews/add",
        name: "add",
        component: () => import("@/views/admin/reviews/function"),
        default: true,
        meta: {
            model: "reviews",
        },
    },
    {
        path: "list-reviews/edit/:id",
        name: "edit",
        component: () => import("@/views/admin/reviews/function"),
        default: true,
        meta: {
            model: "reviews",
        },
    },
];
export default ReviewsRouter;